import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    fill="currentColor"
    d="m3.7 0.3l-1.8 1.1c-0.8 0.5-1.4 1.2-1.6 2.1-1 3.6 0.6 8.1 6.3 13.9 5.8 5.7 10.3 7.3 13.9 6.3 0.9-0.2 1.6-0.8 2.1-1.6l1.1-1.9c0.6-0.9 0.3-2.2-0.7-2.8l-4.5-3-0.1-0.1c-1-0.5-2.1-0.3-2.8 0.5l-1.1 1.5-0.7-0.3c-1.1-0.7-1.7-1.2-3.2-2.6l-0.2-0.3c-1.4-1.4-1.9-2-2.5-3.2l-0.2-0.4 1.5-1.1c0.9-0.7 1.1-2 0.4-2.9l-3-4.5c-0.6-1-1.9-1.3-2.9-0.7z"
  />
);

const Icon = createSvgIcon(svg, 'PhoneFill');

export default Icon;
